import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden nebula-bg">
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/50 z-0" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <h1 className="text-4xl sm:text-6xl font-bold mb-6 text-glow">
            <span className="block text-reveal delay-200">
              Bringing Simplicity
            </span>
            <span className="block text-reveal delay-400">to Complex Business SaaS</span>
          </h1>
          <p className="text-xl sm:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto text-reveal delay-600">
            Empowering businesses with AI-driven solutions for seamless collaboration,
            data analytics, and intelligent decision making.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center text-reveal delay-800">
            <a
              href="#products"
              className="gradient-border bg-black/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg inline-flex items-center hover:bg-black/70 transition-all transform hover:scale-105"
            >
              Explore Our Products
              <ArrowRight className="ml-2" />
            </a>
          </div>
          <div className="mt-8 text-reveal delay-800">
            <span className="text-sm text-gray-400">Powered by AI</span>
          </div>
        </div>
      </div>
    </div>
  );
}